import React from 'react';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import CommonStrings from 'resources/common-strings';
import RuntimeActions from 'data/app-runtime/actions';
import { getInstructionalAreaStrength, sortInstructionalAreas } from './utils';
import Analytics from 'utils/analytics';
import CommonValues from 'resources/common-values';
import HelpBox from 'components/generic/help/index';
import Rit from './rit';

export default CreateReactClass({
    displayName: 'NormalInstructionalAreas',

    propTypes: {
        batchInfo: PropTypes.object /* Only exists when in Batch Print mode */,
        currentTestEvent: PropTypes.instanceOf(Immutable.Map),
        selectGoals: PropTypes.func,
        studentBid: PropTypes.string.isRequired,
        subjectBid: PropTypes.number.isRequired,
    },

    expandFn(event, goals, currentTestEvent, expandedState) {
        if (!!currentTestEvent) {
            this.props.selectGoals(goals);
        }
        RuntimeActions.expandModule(expandedState, null, true); // using a variable instead of passing static value
        Analytics.recordButtonClick(CommonValues.SectionIDs.instructionalAreas, 'expand-module', expandedState);
    },

    helpText() {
        return (
            <div key="instructional-areas-help-content">
                <p key="initial-text"> {CommonStrings.instructionalAreasHelp.initialText}</p>
                <div key="help-link-section">
                    <strong key="help-read-more">{CommonStrings.instructionalAreasHelp.readMoreText}</strong>
                    <a key="help-link" href={CommonStrings.instructionalAreasHelp.helpLink} target="_blank">
                        {' '}
                        {CommonStrings.instructionalAreasHelp.helpLinkText}{' '}
                    </a>
                </div>
            </div>
        );
    },

    render() {
        const goals = [];
        const instructionalAreas = sortInstructionalAreas(this.props.currentTestEvent);

        instructionalAreas.forEach((goal) => {
            const instructionalAreaStrength = getInstructionalAreaStrength(
                this.props.currentTestEvent.get('score'),
                this.props.currentTestEvent.get('standardError'),
                goal.get('score'),
                goal.get('standardError')
            );

            const goalkey = goal.get('goalkey');
            const goalName = goal.get('name');
            const goalScore = goal.get('score');
            const expandFn = this.expandFn;
            const currentTestEvent = this.props.currentTestEvent;
            const goalClasses = 'module-entry';
            goals.push(
                <div key={goalkey} className={goalClasses}>
                    <Rit
                        key={`rit-only-${goalkey}`}
                        goalName={goalName}
                        goalScore={goalScore}
                        expandFn={expandFn}
                        goal={Immutable.List.of(goal)}
                        currentTestEvent={currentTestEvent}
                        instructionalAreaStrength={instructionalAreaStrength}
                    />
                </div>
            );
        });

        if (!instructionalAreas || instructionalAreas.size === 0) {
            goals.push(
                <p key="noTestEvents" className="text-no-test-events">
                    {CommonStrings.noTestEvents}
                </p>
            );
        }

        return (
            <div className="module instructional-areas">
                <header>Instructional Areas</header>
                <HelpBox
                    id={'instructional-area-help-box-' + this.props.studentBid}
                    testid="instructional-area-help-box"
                    appLevelCssClassName="show-normal-instructional-areas-help-box"
                    helpContentsRenderer={this.helpText}
                    moduleName={CommonValues.SectionIDs.instructionalAreas}
                    helpLabel="instructional-areas-default-help"
                />
                <span
                    key="header-expand-btn"
                    className="icon icon-expand"
                    onClick={(event) => {
                        this.expandFn(event, Immutable.List(), this.props.currentTestEvent, 'instructional-areas');
                    }}
                />
                {goals}
            </div>
        );
    },
});
